import { useStore } from "../../../hooks/store";
import Styles from "../Form.module.css";
import CustomField from "../../shared/CustomTextField";
import { Formik } from "formik";
import { Button } from "@mui/material";
import { postSchool } from "../../../utils/API/schoolMethods";

export default function NewSchoolForm() {
  const store = useStore();

  const initValues = {
    name: null,
    description: null,
    login: null,
    role: null,
    password: null,
    password_confirm: null,
  };

  const submitSchool = (values) => {
    postSchool(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        submitSchool(values);
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>Создание автошколы</p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="name"
                  label="Название автошколы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />
                <CustomField
                  name="phone"
                  label="Номер телефона автошколы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.phone}
                />
                <CustomField
                  name="city"
                  label="Город автошколы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.city}
                />
                <CustomField
                  name="ref_code"
                  label="Код приглашения"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.ref_code}
                />
                <CustomField
                  multiline
                  rows={3}
                  name="description"
                  label="Комментарий"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
              </div>
            </div>

            <div className="form_actions">
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
